// claude-allow-convention-check - this package is the single home for date/time formatters.
import { getLabels } from '../labels';
import { formatTime } from './formatTime';
// formatDate(new Date('2025-12-17T14:30:00')) -> "17 Dec 2025" (pl: "17 gru 2025")
// formatDate(new Date('2025-12-17T14:30:00'), true) -> "17 Dec 2025 14:30"
export const formatDate = (date, withTime = false) => `${date.getDate()} ${getLabels().month_short[date.getMonth()]} ${date.getFullYear()}${withTime ? ` ${formatTime(date)}` : ''}`;
